import type { ArticleVisibility } from "./types";

/**
 * Knowledge-base access roles.
 *
 * - "public" — no login; the default for any visitor
 * - "guest"  — logged in as a guest
 * - "admin"  — logged in as an admin (full read + edit)
 */
export type KnowledgebaseRole = "admin" | "guest" | "public";

/** Selectable visibility options, in the order shown in the editor dropdown. */
export const articleVisibilityOptions: ArticleVisibility[] = [
  "everyone",
  "guest",
  "admin",
];

/** The effective visibility of an article (missing → "everyone"). */
export const articleVisibilityOf = (visibility?: ArticleVisibility): ArticleVisibility =>
  visibility ?? "everyone";

/**
 * Whether a role may view an article with the given visibility.
 *
 * Hierarchy: admin sees everything; guest sees guest + everyone;
 * public sees everyone only. A missing visibility is treated as "everyone".
 */
export const canViewArticle = (
  visibility: ArticleVisibility | undefined,
  role: KnowledgebaseRole,
): boolean => {
  if (role === "admin") return true;
  const effective = articleVisibilityOf(visibility);
  if (effective === "admin") return false;
  if (effective === "guest") return role === "guest";
  return true;
};
